// 1, 2, 5
const pluralize = (number, titles) => {
	const n = Math.abs(number);
	return titles[
		(n % 10 === 1 && n % 100 !== 11) ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2
	];
};

export default pluralize;


// WEBPACK FOOTER //
// ./frontend/shared/js/pluralize.js